import settings from "@/components/settings/Settings";
import settingIndex from "@/components/settings/Index";
import locationIndex from "@/components/location/Index";
import virtualVisitEmail from "@/components/settings/VirtualVisitEmailSettings";

export default {
  path: "/settings",
  component: settings,
  meta: {
    permission: "interview:update|interview:manage"
  },
  children: [
    {
      path: "",
      name: "settings-index",
      component: settingIndex,
      meta: {
        title: "Settings",
        permission: "interview:update|interview:manage"
      }
    },
    {
      path: "locations",
      name: "locations-list",
      component: locationIndex,
      meta: {
        title: "Locations",
        permission: "interview:update|interview:manage"
      }
    },
    {
      path: "virtual-visit-email",
      name: "virtual-visit-email",
      component: virtualVisitEmail,
      meta: {
        title: "Virtual Visit Emails",
        permission: "interview:update|interview:manage"
      }
    }
  ]
};
